import { cx } from '@mage-ui/styled-system/css';
import { img } from '@mage-ui/styled-system/recipes';

export const LogoImage = ({ data, className }) => {
	const imagePrefix = '';

	return (
		<img
			src={data?.fields?.img_logo ? imagePrefix + data?.fields?.img_logo : null}
			alt={data?.fields?.alt_img ?? ''}
			className={cx(img({ fit: 'contain' }), className)}
		/>
	);
};
